import { useTranslation } from "react-i18next";
import { StatusChip } from "./ui/ledger";

/**
 * Hujjat / harakat qatoridagi filial yorlig'i.
 *
 * Nomsiz (filialsiz eski yozuv yoki o'chirilgan filial) — "—", ya'ni katak
 * bo'sh qolmaydi va "ma'lumot yo'q" ekani ko'rinadi.
 *
 * Arxivlangan filial ATAYIN ko'rsatiladi: o'tmishdagi hujjat o'sha filialga
 * tegishli bo'lib qolaveradi, uni yashirish tarixni buzardi. Faqat "Nofaol"
 * belgisi qo'shiladi, shunda egasi bu filialda endi savdo ketmayotganini
 * biladi.
 */
export function BranchLabel({
  name,
  isActive,
}: {
  name: string | null | undefined;
  isActive?: boolean | null;
}) {
  const { t } = useTranslation("ombor");
  if (!name) return <span className="text-muted-foreground">—</span>;
  return (
    <span className="inline-flex items-center gap-1.5">
      <span>{name}</span>
      {isActive === false && (
        <StatusChip tone="muted" dot={false}>
          {t("tovars.inactive")}
        </StatusChip>
      )}
    </span>
  );
}
